<template>
    <div class="flex justify-center items-center w-full h-screen">
    <div class="background container">
        <div class="left-side" :style="{ backgroundImage: image }"></div>
        <div class="right-side">
            <div class="login-header">
                <router-link to="/">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512" class="login-close">
                        <path fill="currentColor"
                              d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
                    </svg>
                </router-link>
            </div>
            <div class="login-body">
                <div class="login-logo">
                    <img src="/img/logo/ugt_logo.png" alt="UGT"
                         class="logotipo">
                </div>
                <h2 class="login-title">
                    Login
                </h2>
                <validation-observer ref="login" v-slot="{handleSubmit}">
                    <form class="login-form"
                          @submit.prevent="handleSubmit(enviar)">
                        <validation-provider
                            name="CNPJ"
                            vid="cnpj"
                            rules="required|cnpj"
                            v-slot="{errors}"
                            tag="div"
                            class="form-group"
                        >
                            <div class="form-text">
                                <label for="cnpj">CNPJ</label>
                                <input
                                    type="text"
                                    id="cnpj"
                                    name="cnpj"
                                    v-mask="'##.###.###/####-##'"
                                    v-model="cnpjMask"
                                    maxlength="18"
                                >
                            </div>
                            <p class="errors">{{errors[0]}}</p>
                        </validation-provider>
                        <validation-provider
                            name="senha"
                            vid="senha"
                            rules="required|min:8"
                            v-slot="{errors}"
                            tag="div"
                            class="form-group"
                        >
                            <div class="form-text">
                                <label for="password">Senha</label>
                                <input
                                    type="password"
                                    id="password"
                                    name="password"
                                    v-model="login.password"
                                >
                            </div>
                            <p class="errors">{{errors[0]}}</p>
                        </validation-provider>

                        <div class="login-options">
                            <div class="form-checkbox">
                                <label>
                                    <input
                                        type="checkbox"
                                        id="remember"
                                        name="remember"
                                        v-model="login.remember"
                                    >
                                    <span class="slider"></span>
                                    <span class="text-dark-gray font-medium">Lembrar-me</span>
                                </label>
                            </div>

                        </div>

                        <div class="login-buttons">
                            <router-link to="/esqueci-minha-senha">Esqueceu a sua senha?</router-link>
                            <button class="btn btn-primary">Entrar</button>
                        </div>
                    </form>
                </validation-observer>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
    import { mask } from "vue-the-mask"
    import { sample } from "lodash"

    export default {
        name: "login",
        directives: { mask },
        data() {
            return {
                image: '',
                images: [
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-001.png)',
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-002.png)',
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-003.png)',
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-004.png)',
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-005.png)',
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-006.png)',
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-007.png)',
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-008.png)',
                    'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-login/bg-header-009.png)'
                ],
                cnpjMask: '',
                login: {
                    cnpj: '',
                    password: '',
                    grant_type: 'password',
                    client_id: 2,
                    client_secret: process.env.OAUTH_KEY,
                }
            }
        },

        methods: {
            changeBg() {
                this.image = sample(this.images);
            },

            /**
             * Realiza o login na aplicação
             */
            enviar() {
                this.login.cnpj = this.cnpjMask.replace(/[^\d]+/g,'')
                this.axios.post('login', this.login).then(response => {
                    this.$store.commit({
                        type: 'auth/setToken',
                        name: 'solluti.com.br',
                        token: response.data.token,
                        expiration: response.data.expires_in,
                    });
                    this.$store.dispatch('user/do_set_user', response.data.usuario).then(() => {
                        if (response.data.usuario.inadimplente === 0) {
                            this.$router.push('/painel-administrativo')
                        } else {
                            this.$swal({
                                title: 'Você possui débitos pendentes',
                                text: 'Para regularizar sua situação financeira entre em contato através do telefone (11) 99492-6889 ou através do e-mail financeiro@ugt-sp.org.br',
                                icon: 'warning',
                            });
                            this.$store.dispatch('user/do_reset_user').then(() => {
                                this.$store.commit('auth/destroyToken');
                            })
                        }
                    }).catch(error => {
                        console.log(error)
                    })
                }).catch(errors => {
                    if (errors.response.status === 422) {
                        this.$refs.login.setErrors(errors.response.data.errors);
                    }
                    this.$swal({
                        title: 'Ops!',
                        text: 'CNPJ ou Senha inválidos',
                        icon: 'error',
                    });
                })
            }
        },

        mounted() {
            this.changeBg();
        },
    }
</script>

<style lang="scss" scoped>
    @import "login";
</style>
